import { combineReducers } from 'redux';
import accounts from './accounts';
import { alerts, selectors as alertsSel } from './alerts';
import apiKey from './apiKey';
import asset from './asset';
import events from './events';
import assets from './assets';
import assetsForAutoComplete from './assetsForAutoComplete';
import changes from './changes';
import currentUser from './currentUser';
import organizations from './organizations';
import search from './search';
import activities from './activities';
import saveStatus from './saveStatus';
import userSearch from './userSearch';
import { makeAsyncSelectors } from '../../../ui-lottery/src/utils/async_utils';

const { isLoading, isLoaded, getState, getErrors, hasErrors } = makeAsyncSelectors('portal');

const reducers = combineReducers({
  accounts,
  alerts,
  apiKey,
  asset,
  assets,
  assetsForAutoComplete,
  changes,
  currentUser,
  events,
  organizations,
  search,
  userSearch,
  saveStatus,
  activities
});

export default reducers;

export {
  alertsSel,
  isLoading,
  isLoaded,
  getState,
  getErrors,
  hasErrors
};
